// Central place for business info and product data — edit content here.
// To replace a product photo, drop a new file with the same name into /public/images/.

export const COMPANY = "ORGANIKTHINGS LLP";
export const PHONE_DISPLAY = "+91 97536 07101";
export const PHONE_TEL = "tel:+919753607101";
export const WHATSAPP = "919753607101";
export const EMAIL = "reachorganicthings@gmail.com";
export const WEBSITE = "www.organikthingsllp.in";
export const ADDRESS =
  "Near Nexa Showroom, AB Road, Dewas Naka, Indore, Madhya Pradesh – 452010";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;

export const PRODUCTS = [
  {
    id: "leaf-plates",
    name: "Green Leaf Plates",
    image: "/images/plate-green.jpg",
    alt: "Natural green leaf plate by Organik Things, top view",
    desc: "Sturdy plates made from natural leaves — a biodegradable alternative to plastic and paper disposables.",
    uses: "Popular with caterers, event organisers, restaurants and sweet shops.",
  },
  {
    id: "leaf-bowls",
    name: "Leaf Bowls & Dona-Pattal",
    image: "/images/bowl-deep.jpg",
    alt: "Natural green leaf bowl (dona) by Organik Things, top view",
    desc: "Traditional leaf bowls and dona-pattal for serving curries, dal, desserts and side dishes — fully biodegradable and plastic-free.",
    uses: "Ideal for caterers, temples, street food vendors and takeaways.",
  },
  {
    id: "leaf-thalis",
    name: "Leaf Thalis & Partition Plates",
    image: "/images/leaf-thalis.jpg",
    alt: "Leaf thali with partitions serving a full Indian meal",
    desc: "Traditional leaf thalis and partition plates for full meals — a natural serving solution with an authentic, premium feel.",
    uses: "Suited to weddings, functions, thali restaurants and large catering orders.",
  },
  {
    id: "grass-straws",
    name: "Grass Straws",
    image:
      "https://images.pexels.com/photos/8573998/pexels-photo-8573998.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Natural grass drinking straws",
    desc: "Natural grass straws — a simple, biodegradable swap for plastic straws.",
    uses: "Made for hotels, cafes, restaurants, juice bars and events.",
    supplementary: true, // representative photo shown until our own product photo is added
  },
];

export const GALLERY = {
  hero: "/images/hero.jpg",
  bowlServing: "/images/bowl-serving.jpg",
  thaliSpread: "/images/thali-spread.jpg",
  plateGreen: "/images/plate-green.jpg",
  plateFresh: "/images/plate-fresh.jpg",
  plateOlive: "/images/plate-olive.jpg",
  plateLarge: "/images/plate-large.jpg",
  bowlDeep: "/images/bowl-deep.jpg",
  bowlSmall: "/images/bowl-small.jpg",
  setNested: "/images/set-nested.jpg",
  thaliMeal: "/images/thali-meal.jpg",
};

export const BENEFITS = [
  {
    icon: "Leaf",
    title: "Natural & Biodegradable",
    desc: "Products made from natural materials that break down naturally — real alternatives to single-use plastic.",
  },
  {
    icon: "Ban",
    title: "Plastic-Free Design",
    desc: "Designed without plastic, in line with our business proposal for cleaner, greener disposables.",
  },
  {
    icon: "Layers",
    title: "Dual-Layer Construction",
    desc: "Built using biodegradable cardboard and glue for dependable strength in everyday use.",
  },
  {
    icon: "Wallet",
    title: "Sustainable & Affordable",
    desc: "Focused on keeping eco-friendly alternatives affordable for businesses of every size.",
  },
  {
    icon: "Users",
    title: "Supports Tribal Women",
    desc: "Our work supports livelihoods for tribal women and keeps traditional craftsmanship alive.",
  },
  {
    icon: "Sprout",
    title: "Eat, Throw & Grow",
    desc: "An innovative seed feature described in our proposal — use it, dispose of it, and let it grow.",
  },
];

export const FAQS = [
  {
    q: "How do I place a bulk or wholesale order?",
    a: "Send us an enquiry through the contact form, WhatsApp, phone or email with the products and quantities you need. Our team will get back to you with bulk pricing and availability. We do not publish prices on the website — all pricing is shared directly with business buyers.",
  },
  {
    q: "How can I become a dealer or distributor?",
    a: "Fill in the partnership enquiry form on our Dealer & Distribution page or message us on WhatsApp. Dealership and distribution terms are discussed individually with each partner based on their region and requirements.",
  },
  {
    q: "Are your products available in my city?",
    a: "We are based in Indore, Madhya Pradesh, and our growth roadmap includes a district-wise dealer network across India, with local dealers within a 10–20 km radius. Contact us to check product availability and supply options for your area.",
  },
  {
    q: "Do you offer white-label partnership?",
    a: "Yes. Eligible partners can explore selling our eco-friendly products under their own brand name. Reach out through the partnership enquiry form to discuss whether this model fits your business.",
  },
  {
    q: "What is the fastest way to reach your team?",
    a: "WhatsApp or a phone call to +91 97536 07101 is the quickest. You can also email reachorganicthings@gmail.com — share your product, quantity and city so we can respond with the right details.",
  },
];
